// extracted by mini-css-extract-plugin
export default {"card":"b6-z"};